import { createSlice } from '@reduxjs/toolkit';

/*
 * Note: currentTime using as dependency for useMemo for checking active game states
 */

const initialState = {
  currentTime: Date.now(),
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    SET_CURRENT_TIME(state, action) {
      state.currentTime = action.payload;
    },
  },
});

export default gameSlice.reducer;
export const { SET_CURRENT_TIME } = gameSlice.actions;
